import { Route, Routes, useLocation } from "react-router-dom";
import { Layout } from "antd";
import PrivateRoute from "../../components/Routing/PrivateRoute";

// import pages
import Dashboard from "../../pages/Dashboard";
import DashboardOverview from "../../pages/DashboardOverview";
import Home from "../../pages/Home";
import Pricing from "../../pages/Pricing";
import Candidate from "../../pages/Candidate";
import Login from "../auth/Login";
import Register from "../auth/Register";
import EmailVerification from "../auth/EmailVerification";
import ForgotPassword from "../auth/ForgotPassword";
import Logout from "../auth/Logout";
import Profile from "../user/Profile";
import AccountSettings from "../user/AccountSettings";
import DailyUpdates from "../user/DailyUpdates";
import Bid from "../bid/Bid";
import AutoBid from "../bid/AutoBid";
import ResumePreview from "../bid/ResumePreview";
import ChartPage from "../ChartPage";
import PersonalStatistic from "../PersonalStatistic";
import Calls from "../call/Calls";
import CalendarPage from "../calendar/CalendarPage";
import NotFound from "./NotFound";
import PromptPage from "../PromptPage";
import InterviewPage from "../interview/InterviewPage";
import Screenshots from "../screenshots/Screenshots";
import ChatPage from "../chat/ChatPage";
import Analyze from "../bid/Analyze";
import TeamMates from "../user/TeamMates";
import JobPosting from "../JobPosting";
import EmailTemplate from "../user/EmailTemplate";
import ManageProfiles from "../user/ManageProfiles";
import Permissions from "../user/Permissions";
import PriceSettings from "../user/PriceSettings";
import Billing from "../user/Billing";
import Unauthorized from "./Unauthorized";
import Games from "../Games";
import JobBoard from "../JobBoard";
import JobBoardSettings from "../JobBoardSettings";
import Guide from "../Guide";
import News from "../user/News";

const { Content } = Layout;

const MainSection = () => {
  const location = useLocation();
  const isTeamChat = location.pathname === "/team-chat";

  return (
    <Content className="app-content">
      <div className={`main-content${isTeamChat ? " team-chat-content" : ""}`}>
        <Routes>
          <Route path="/login" element={<Login title="Login" />} />
          <Route path="/" element={<Home title="Resume Builder" />} />
          <Route path="/pricing" element={<Pricing title="Pricing" />} />
          <Route path="/games" element={<Games title="Games" />} />
          <Route
            path="/guide"
            element={<PrivateRoute component={() => <Guide title="Guide" />} />}
          />
          <Route
            path="/job-board"
            element={
              <PrivateRoute
                pageKey="dashboard"
                component={() => <JobBoard title="Job Board" />}
              />
            }
          />
          <Route
            path="/job-board-settings"
            element={
              <PrivateRoute
                adminOnly
                pageKey="jobBoardSettings"
                component={() => (
                  <JobBoardSettings title="Job Board Settings" />
                )}
              />
            }
          />
          <Route
            path="/billing"
            element={
              <PrivateRoute
                pageKey="billing"
                component={() => <Billing title="Billing" />}
              />
            }
          />
          <Route
            path="/price-settings"
            element={
              <PrivateRoute
                adminOnly
                component={() => <PriceSettings title="Price Settings" />}
              />
            }
          />
          <Route
            path="/news"
            element={
              <PrivateRoute
                adminOnly
                component={() => <News title="News & Announcements" />}
              />
            }
          />
          <Route path="/register" element={<Register title="Register" />} />
          <Route
            path="/verify-email"
            element={<EmailVerification title="Verify Email" />}
          />
          <Route
            path="/forgot-password"
            element={<ForgotPassword title="Forgot Password" />}
          />
          <Route
            path="/forgot-password/verify"
            element={<ForgotPassword title="Verify Reset Code" step="verify" />}
          />
          <Route
            path="/forgot-password/reset"
            element={
              <ForgotPassword title="Create New Password" step="reset" />
            }
          />
          <Route path="/logout" element={<Logout title="Logging out..." />} />
          <Route
            path="/unauthorized"
            element={
              <PrivateRoute
                component={() => <Unauthorized title="Access Denied" />}
              />
            }
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute
                pageKey="dashboard"
                component={() => <DashboardOverview title="Dashboard" />}
              />
            }
          />
          <Route
            path="/applications"
            element={
              <PrivateRoute
                pageKey="dashboard"
                component={() => <Dashboard title="Applications" />}
              />
            }
          />
          <Route
            path="/candidate"
            element={
              <PrivateRoute
                pageKey="candidates"
                component={() => <Candidate title="Candidates" />}
              />
            }
          />
          <Route
            path="/job-posting"
            element={
              <PrivateRoute
                pageKey="jobPosting"
                component={() => <JobPosting title="Job Posting" />}
              />
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute
                pageKey="profile"
                component={() => <Profile title="Profile" />}
              />
            }
          />
          <Route
            path="/team-chat"
            element={
              <PrivateRoute
                pageKey="teamChat"
                component={() => <ChatPage title="Team Chat" />}
              />
            }
          />
          <Route
            path="/team-mate"
            element={
              <PrivateRoute
                pageKey="teamMates"
                component={() => <TeamMates title="Teammates" />}
              />
            }
          />
          <Route
            path="/account-settings"
            element={
              <PrivateRoute
                pageKey="accountSettings"
                component={() => <AccountSettings title="Account Settings" />}
              />
            }
          />
          <Route
            path="/manage-profiles"
            element={
              <PrivateRoute
                pageKey="manageProfiles"
                component={() => <ManageProfiles title="Manage Profiles" />}
              />
            }
          />
          <Route
            path="/permissions"
            element={
              <PrivateRoute
                adminOnly
                component={() => <Permissions title="Permissions" />}
              />
            }
          />
          <Route
            path="/email-template"
            element={
              <PrivateRoute
                pageKey="emailTemplate"
                component={() => <EmailTemplate title="Email Template" />}
              />
            }
          />
          <Route
            path="/daily-report"
            element={
              <PrivateRoute
                pageKey="dailyReport"
                component={() => <DailyUpdates title="Daily Report" />}
              />
            }
          />
          <Route
            path="/bid"
            element={
              <PrivateRoute
                pageKey="bid"
                component={() => <Bid title="Bid" />}
              />
            }
          />
          <Route
            path="/auto-bid"
            element={
              <PrivateRoute
                pageKey="bid"
                component={() => <AutoBid title="Auto Bid" />}
              />
            }
          />
          <Route
            path="/resume-preview"
            element={
              <PrivateRoute
                pageKey="bid"
                component={() => <ResumePreview title="Resume Preview" />}
              />
            }
          />
          <Route
            path="/analyze"
            element={
              <PrivateRoute
                pageKey="analyze"
                component={() => <Analyze title="Analyze" />}
              />
            }
          />
          <Route
            path="/statistic"
            element={
              <PrivateRoute
                pageKey="statistic"
                component={() => <ChartPage title="Team Statistic" />}
              />
            }
          />
          <Route
            path="/resume-preview/:bidId"
            element={
              <PrivateRoute
                pageKey="bid"
                component={() => <ResumePreview title="Resume Preview" />}
              />
            }
          />
          <Route
            path="/personal-statistic"
            element={
              <PrivateRoute
                pageKey="personalStatistic"
                component={() => <PersonalStatistic title="Statistic" />}
              />
            }
          />
          <Route
            path="/interview/:id"
            element={
              <PrivateRoute
                pageKey="interview"
                component={() => <InterviewPage title="AI Interview" />}
              />
            }
          />
          <Route
            path="/calls"
            element={
              <PrivateRoute
                pageKey="calls"
                component={() => <Calls title="Interviews" scope="personal" />}
              />
            }
          />
          <Route
            path="/team-interviews"
            element={
              <PrivateRoute
                pageKey="teamCalls"
                component={() => <Calls title="Team Interviews" scope="team" />}
              />
            }
          />
          <Route
            path="/calendar"
            element={
              <PrivateRoute
                pageKey="calendar"
                component={() => (
                  <CalendarPage title="Calendar" scope="personal" />
                )}
              />
            }
          />
          <Route
            path="/team-calendar"
            element={
              <PrivateRoute
                pageKey="teamCalendar"
                component={() => (
                  <CalendarPage title="Team Calendar" scope="team" />
                )}
              />
            }
          />
          <Route
            path="/prompt"
            element={
              <PrivateRoute
                pageKey="prompt"
                component={() => <PromptPage title="Update Prompt" />}
              />
            }
          />
          <Route
            path="/screenshots"
            element={
              <PrivateRoute
                pageKey="screenshots"
                component={() => <Screenshots title="Screenshots" />}
              />
            }
          />
          <Route path="/*" element={<NotFound title="Page Not Found" />} />
        </Routes>
      </div>
    </Content>
  );
};

export default MainSection;
